module.exports = __webpack_public_path__ + "img/fail.55c23a06.png";